<template>
  <div class="home">
    <template v-if="data">
      <TopBar
        :deaths="data.totals.deaths"
        :cases="data.totals.cases"
      />
      <CovidMap
        :rawDistricts="data.districts"
        :rawBuildings="data.buildings"
        :timestamp="data.timestamp"
      />
    </template>
    <template v-else-if="error">
      <div class="centered">
        <h3 style="text-align:center;">
          {{this.error}}
        </h3>
      </div>
    </template>
    <template v-else>
      <div class="spinner"></div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import TopBar from "@/components/TopBar.vue";
import CovidMap from "@/components/CovidMap.vue";

export default {
  name: "Home",
  data() {
    return {
      data: '',
      error: ''
    }
  },
  components: {
    TopBar,
    CovidMap
  },
  mounted () {
    axios
      .get('https://raw.githubusercontent.com/njwest/HK-COVID-Building-Data/master/data.json')
      .then(response => {
        this.data = response.data
      })
      .catch(error => {
        // console.log(error)
        this.error = error
      })
  }
};
</script>

<style>
.home {
  width: 100%;
  height: 100%;
}

.spinner {
  width: 40px;
  height: 40px;
  background-color: #333;

  margin: 100px auto;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@-webkit-keyframes sk-rotateplane {
  0% { -webkit-transform: perspective(120px) }
  50% { -webkit-transform: perspective(120px) rotateY(180deg) }
  100% { -webkit-transform: perspective(120px) rotateY(180deg)  rotateX(180deg) }
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
  } 50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
  } 100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
</style>
